import {
  faCartShopping,
  faHeart,
  faMagnifyingGlass,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components/macro';
import { WxLabel } from '../..';
import { __ } from '../../../i18n/l10n';

type NotFoundType = 'product' | 'cart' | 'favorites' | 'orders';

interface Props {
  type: NotFoundType;
  black?: boolean;
}

const icon = (type: NotFoundType) => {
  switch (type) {
    case 'product':
      return faMagnifyingGlass;
    case 'cart':
      return faCartShopping;
    case 'favorites':
      return faHeart;
    case 'orders':
      return faHeart;
  }
};

const label = (type: NotFoundType) => {
  switch (type) {
    case 'product':
      return __('No results found');
    case 'cart':
      return __('Empty cart');
    case 'favorites':
      return __('No favourites');
    case 'orders':
      return __('No order');
  }
};

export const EmptyPlaceholder = ({ type, black = false }: Props) => {
  return (
    <DivNotFound>
      <BigFontAwesomeIcon icon={icon(type)} />
      <DivAbsoluteCenteredLabel>
        <WxLabel label={label(type)} black={black} />
      </DivAbsoluteCenteredLabel>
    </DivNotFound>
  );
};

const DivNotFound = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 32rem;
  color: ${({ theme }) => theme.colors.white};
`;

const DivAbsoluteCenteredLabel = styled.div`
  position: absolute;
`;

const BigFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.red};
  font-size: 3.125rem;
`;
